<template>
  <div class="main">
    <layout />
    <TopbgVue :title="title" />
    <div class="list">
      <div class="item-title">{{ title }}</div>
      <div class="ul">
        <div @click="toDetail(item)" class="li" v-for="(item, index) in listData" :key="index">
          <div class="li-title">{{ item.title }}</div>
          <div class="li-text">{{ item.time }}</div>
          <div class="li-text">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import TopbgVue from "./Topbg.vue";
import Footer from './footer.vue';
import Layout from './Layout.vue';
export default {
  data() {
    name:'Usedidle'
    return {
      title: "二手闲置",
      listData:[{
        title:'小米58寸智能彩电',
        time:'24-01-01',
        text:'才买的不到二年，ViP到11月份，在保期内一年。带​‌‌有机座，原装遥控器联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌'
      },{
        title:'筋膜枪低价出',
        time:'24-01-01',
        text:'自用筋膜枪，没怎么用，售出不退，新旧如图​‌‌联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌‌'
      },{
        title:'华为p9手机',
        time:'24-01-02',
        text:'搬家翻出来的，屏幕底下有一个小黑点，不影响触摸和使​‌‌用，不介意的给我打电话过来自取，130拿走，售出不退不换联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌​‌‌​‌‌'
      },{
        title:'8寸亚迪专业卡拉OK音箱',
        time:'24-01-03',
        text:'8寸亚迪专业卡拉OK音箱350转让，三分频专业歌房​‌‌音箱，人声清晰嘹亮。功放300元转让。全套600元带走，不含邮费联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌​‌‌​‌‌​‌‌'
      },{
        title:'四核i7平时教学做课件的联想笔记本',
        time:'24-01-04',
        text:'联想thinkpad品牌的笔记本电脑，黑色，14寸​‌‌，高清屏，有无线，蓝牙，摄像头，酷睿i7的，硬盘500g，显卡2g，系统是w7的64位系统，我们教学要求统一w7系统，这个可以免费升级w10，配件有笔记本包，鼠标，鼠标垫，保卡，电源，电池，都原装的，说明一下，这个是因为2020年初疫情，学校要求教师必须在家做课件，然后在家给学生上网课，然后学校统一采购的给上课老师发的教学本，用了不到一年，基本做课件，上网课，放投影用的，现在正式开学了，我自己本身有笔记本，这个就很少使用，闲置了，今天想转让给需要的，适合学生学习，办公，设计也可以，这个大型制图，设计没问题，配置主流配置，一年时间，这个保期两年，配件都一起，您拿回去直接可以使用，速度很快，毕竟刚一年，95新以上，诚意可以实际把您需要软件装上，自己用用，合适拿走.诚意转让联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌‌'
      }]
    };
  },
  components: {
    TopbgVue,
    Layout,
    Footer
  },
  mounted() {
    // this.title = this.$route.query.title;
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path:'/detail',
        query: {
          title: item.title,
          text: item.time,
          detail: item.text,
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.list {
  max-width: 1320px;
  margin: 80px auto 0;
  .item-title {
    margin-bottom: 30px;
    font-size: 24px;
    font-weight: bold;
    color: #0099cc;
  }
  .ul {
    padding: 0 30px 50px 200px;
    background: #f0f8ff;
    .li {
      padding-top: 50px;
      .li-title {
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
        color: #000000;
      }
      .li-text {
        padding-top: 10px;
        font-size: 16px;
        color: #717275;
      }
      .li-text:nth-child(2) {
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; /*省略几行写几*/
        -webkit-box-orient: vertical;
      }
    }
  }


}
</style>